export enum TableNames {
  MY_PA_ORDERS = "my_pa_orders",
  MEDICAL_PA_ORDERS_NEW = "medical_pa_orders_new",
  ALL_PA_ORDERS = "all_pa_orders",
  GENERIC_AUTH_STATUS_ORDERS = "generic_auth_status_table",
  DRAFT_SUBMISSION_CPT_TABLE = "draft_submission_cpt_table",
  CLINICAL_DATA = "clinical-data",
  MY_PA_ORDERS_FROM_ALGOLIA = "my_pa_orders_from_algolia",
}
